<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-1",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 1,
      nextPage: '/questionnaire/section1/2',
      navigateType: 'INPUT_SUBMIT',
      content: {
        mainTitle: 'What\'s your first name?',
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
